import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LotteryService } from 'src/app/services';
import { gsap } from "gsap";
import { Router } from '@angular/router';

@Component({
  selector: 'app-hero-7-days-countdown',
  templateUrl: './hero-7-days-countdown.component.html',
  styleUrls: ['./hero-7-days-countdown.component.scss']
})
export class Hero7DaysCountdownComponent implements OnInit {

  public nextDrawDate = new Date();
  public saleStopDays: number;

  private router: Router;
  private readonly lotteryService: LotteryService;

  constructor(lotteryService: LotteryService, router: Router) 
  {
    this.lotteryService = lotteryService;
    this.router = router;
  }

  public ngOnInit(): void 
  {
    this.getNextSaleStop();
    this.animateHeader();
    this.getNextLotteryClassMonth();
  }

  public redirectShop(): void 
  {
    this.router.navigateByUrl("/lodder-til-salg/lodder");
  }

  public getNextSaleStop(): void
  {
    this.lotteryService.getSaleStop().subscribe((salestop) => {

      const seconds = parseInt(salestop.Seconds, 10) || 0;
      const minutes = parseInt(salestop.Minutes, 10) || 0;
      const hours = parseInt(salestop.Hours, 10) || 0;
      const days = parseInt(salestop.Days, 10) || 0;
      
      const today = new Date();

      const x = new Date();
      x.setDate(x.getDate() + days);
      x.setHours(x.getHours() + hours);
      x.setMinutes(x.getMinutes() + minutes);
      x.setSeconds(x.getSeconds() + seconds);

      if(hours > 10)
      {
        this.saleStopDays = days + 1;
      }
      else
      {
        this.saleStopDays = days;
      }

      if(today.getTime() >= x.getTime())
      {
        this.saleStopDays = null;
      }
    });
  }

  public getNextLotteryClassMonth(): void
  {
    this.lotteryService.getNextBsLotteryClass().subscribe((nextlotteryclass) => {
      this.nextDrawDate = nextlotteryclass.DankortLastSale;
    });
  }
  
  public animateHeader(): void
  {
    gsap.registerEffect({
      name: "pulse",
      effect: (targets, config) => {
        tl = gsap.timeline({repeat: 3, repeatDelay: 0.3 });
        tl.to(targets, { scale: 1.2, duration: 0.3, ease: "back.in(4)" })
          .to(targets, { scale: 1, duration: 0.3, ease: "back.out(4)" });
        return tl
      },
      defaults: {duration: 0.5},
      extendTimeline: true
    });
    
    var tl = gsap.timeline({repeat: -1, repeatDelay: 10});
  
    tl.add("start");
    
    tl.from(".txt1", {autoAlpha:0}, "+=0.3")
      .fromTo(".txt2", {y: 1500, rotate: 90},
      { duration: 1, 
        y: -16,
        rotate: -10,     
        ease: "power4.out",
        }, ">")
      .from(".txt3", {autoAlpha:0}, ">")
      .from(".cta", {autoAlpha:0}, ">")
      .fromTo(".splash", {y: 1500, rotate: 90},
      { duration: 1, 
        y: 0,
        rotate: 0,     
        ease: "power4.out",
        }, ">")
      .pulse(".pulse", "+=2"); 
  }
}